/**
 * Typed access to Vite env vars. Import this instead of touching
 * `import.meta.env` directly so defaults live in exactly one place.
 */

function bool(value: string | undefined, fallback: boolean): boolean {
  if (value === undefined || value === '') return fallback;
  return value === 'true' || value === '1';
}

function int(value: string | undefined, fallback: number): number {
  const parsed = Number.parseInt(value ?? '', 10);
  return Number.isFinite(parsed) ? parsed : fallback;
}

export const env = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? '/api/v1',
  useMocks: bool(import.meta.env.VITE_USE_MOCKS, import.meta.env.DEV),
  mockLatency: int(import.meta.env.VITE_MOCK_LATENCY, 350),
  /** backend wraps responses in ApiResponse<T> */
  apiEnvelope: bool(import.meta.env.VITE_API_ENVELOPE, true),
  storagePrefix: import.meta.env.VITE_STORAGE_PREFIX ?? 'cqts',
  isDev: import.meta.env.DEV,
} as const;

export const storageKeys = {
  accessToken: `${env.storagePrefix}.accessToken`,
  refreshToken: `${env.storagePrefix}.refreshToken`,
  user: `${env.storagePrefix}.user`,
  mockDb: `${env.storagePrefix}.mockDb`,
  sidebar: `${env.storagePrefix}.sidebarCollapsed`,
  dateFilter: `${env.storagePrefix}.dateFilter`,
} as const;
